<div class="fuse-toast" [ngClass]="['fuse-toast-type-' + toast.type, 'fuse-toast-variant-' + toast.variant]">
    <div class="fuse-toast-container">
        <div class="fuse-toast-border"></div>
        <div class="fuse-toast-icon" *ngIf="toast.icon">
            <mat-icon>{{ toast.icon }}</mat-icon>
        </div>
        <div class="fuse-toast-content">
            <div class="fuse-toast-title" *ngIf="toast.title">{{ toast.title }}</div>
            <div class="fuse-toast-message">{{ toast.message }}</div>
        </div>
        <button class="fuse-toast-dismiss-button" *ngIf="toast.dismissible" (click)="dismiss()" [attr.aria-label]="'common.aria.close' | transloco">
            <mat-icon svgIcon="heroicons_outline:x-mark" aria-hidden="true"></mat-icon>
        </button>
    </div>
</div>
